import { formatDate } from '@lingoda/dates';
import { DATE_SELECTED_ON_MULTIPLE_DAY_FILTER } from '../models';
import type { BookClassEvent } from '../models';

export const mapDatesToEvent = (dates: Date[]): Partial<BookClassEvent> => ({
    [DATE_SELECTED_ON_MULTIPLE_DAY_FILTER]: dates.map((date) => formatDate(date)).join('; '),
});
